import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import myImg from "../../Assets/avatar.webp";
import Tilt from "react-parallax-tilt";
import {
  AiFillGithub,
  AiFillInstagram,
} from "react-icons/ai";
import { FaLinkedinIn } from "react-icons/fa";

// Custom X (Twitter) icon component
const XIcon = () => (
  <svg
    viewBox="0 0 24 24"
    width="0.7em"
    height="0.7em"
    fill="currentColor"
    style={{ margin: "auto" }}
  >
    <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z" />
  </svg>
);

function Home2() {
  return (
    <Container fluid className="home-about-section" id="about">
      <Container>
        <Row>
          <Col md={8} className="home-about-description">
            <h1 style={{ fontSize: "2.6em" }}>
              LET ME <span className="purple"> INTRODUCE </span> MYSELF
            </h1>
            <p className="home-about-body">

              I'm a passionate 
              <i>
                <b className="purple"> Software Developer </b>
              </i>
              who enjoys building meaningful web applications with modern technologies.

              <br />
              <br />
              
              I mainly work with 
              <i>
                <b className="purple"> Java, Spring Boot, React, </b>
              </i>
              and
              <i>
                <b className="purple"> TypeScript </b>
              </i>
              , and I also follow the latest trends in
              <i>
                <b className="purple"> Artificial Intelligence </b>
              </i>
              , aiming to apply them in real-world projects.

              <br />
              <br />

              As a
              <i>
                <b className="purple"> freelancer </b> and
              </i>
              , I have developed full-stack applications and enjoy taking part in every step—from backend logic to frontend user experience.

              <br />
              <br />

              Let's build something great together!
            </p>
          </Col>
          <Col md={4} className="myAvtar">
            <Tilt>
              <img src={myImg} className="img-fluid" alt="avatar" />
            </Tilt>
          </Col>
        </Row>
        <Row>
          <Col md={12} className="home-about-social">
            <h1>FIND ME ON</h1>
            <p>
              Feel free to <span className="purple">connect </span>with me
            </p>
            <ul className="home-about-social-links">
              <li className="social-icons">
                <a
                  href="https://github.com/uurkrtl"
                  target="_blank"
                  rel="noreferrer"
                  className="icon-colour home-social-icons"
                >
                  <AiFillGithub style={{ fontSize: "0.7em" }} />
                </a>
              </li>
              <li className="social-icons">
                <a
                  href="https://x.com/uurkrtl"
                  target="_blank"
                  rel="noreferrer"
                  className="icon-colour home-social-icons"
                >
                  <XIcon />
                </a>
              </li>
              <li className="social-icons">
                <a
                  href="https://www.linkedin.com/in/ugurkartal/"
                  target="_blank"
                  rel="noreferrer"
                  className="icon-colour home-social-icons"
                >
                  <FaLinkedinIn style={{ fontSize: "0.7em" }} />
                </a>
              </li>
              <li className="social-icons">
                <a
                  href="https://www.instagram.com/uurkrtl"
                  target="_blank"
                  rel="noreferrer"
                  className="icon-colour home-social-icons"
                >
                  <AiFillInstagram style={{ fontSize: "0.7em" }} />
                </a>
              </li>
            </ul>
          </Col>
        </Row>
      </Container>
    </Container>
  );
}
export default Home2;
